import axios from 'axios'

export const conditionMonitoringAPI = function (baseURL) {
  this.host = baseURL ? baseURL : 'https://' + window.location.hostname
}

conditionMonitoringAPI.prototype.getURL = function (path) {
  return `${this.host}${path}`
}

conditionMonitoringAPI.prototype.getProtocolList = function () {
  const url = this.getURL('/ib/api/v1/protocol/list')
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getOneProtocol = function (id) {
  const url = this.getURL('/ib/api/v1/protocol/' + id)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getOneProtocolTemplate = function (machine_no) {
  const url = this.getURL('/ib/api/v1/protocol/template/' + machine_no)
  return axios.post(url, null, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getMeasurementViewTemplate = function (platform) {
  // const query = chain != null && chain.length > 0 ? `?chain=${chain}` : ''
  const url = this.getURL(`/ib/api/v1/measurement/template/${platform}`)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.createProtocol = function (protocol) {
  const url = this.getURL('/ib/api/v1/protocol')
  return axios.post(url, protocol, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getMeasurementViewList = function (protocolID) {
  const url = this.getURL('/ib/api/v1/measurement/list/' + protocolID)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getOneMachine = function (no) {
  const url = this.getURL('/ib/api/v1/installed-base/' + no)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.saveProtocol = function (data) {
  const url = this.getURL('/ib/api/v1/protocol')
  return axios.put(url, data, {withCredentials: true})
}
conditionMonitoringAPI.prototype.getInstalledBaseList = function (limit) {
  if (limit == null) {
    limit = 100
  }
  const url = this.getURL('/ib/api/v1/installed-base/machines?limit=' + limit)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getInstalledBaseByProject = function (project_id) {
  const url = this.getURL('/ib/api/v1/installed-base/machines/project/' + project_id)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getParamList = function () {
  const url = this.getURL('/ib/api/v1/param/list')
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getOneParam = function (paramID) {
  const url = this.getURL('/ib/api/v1/param/' + paramID)
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.createMeasurementParameter = function (data) {
  const url = this.getURL('/ib/api/v1/param')
  return axios.post(url, data, {withCredentials: true})
}

conditionMonitoringAPI.prototype.updateMeasurementParameter = function (data) {
  const url = this.getURL('/ib/api/v1/param')
  return axios.put(url, data, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getProductProps = function () {
  const url = this.getURL('/ib/api/v1/settings/product-props')
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getInstructions = function () {
  const url = this.getURL('/private/cm/instructions')
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.getChains = function () {
  const url = this.getURL('/ib/api/v1/settings/conveyor-chains-chains')
  return axios.get(url, {withCredentials: true})
}

conditionMonitoringAPI.prototype.openFlexLinkInTheWorld = function () {
  const url = this.getURL('/ib/api/v1/redirect/flexlink-in-the-world')
  window.location = url
}